import React from 'react';
import { Icon } from 'b3';
import './call-button.less';
import { ShortCutTooltip } from 'c3';
import ReactTooltip from 'react-tooltip';

export default class CallButton extends React.Component {
	static defaultProps = {
		onClick: () => {},
	};
	handleClick() {
		ReactTooltip.hide(this.icon);

		this.props.onClick();
	}
	render() {
		var { icon, label, onClick, shortcutKey } = this.props;

		return (
			<span
				className="call-button"
				onClick={this.handleClick.bind(this)}
			>
				<Icon ref={el => this.icon = el} icon={icon} size="20" filled showTooltipFor={icon} />
				<ShortCutTooltip id={icon} label={label} onShortCutKeyPressed={onClick} shortcutKey={shortcutKey} />
			</span>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/nav-call-buttons/CallButton.js